'use client';
import { type ComponentType } from 'react';

import { useSystemTheme } from '../../../hooks/helpers/useSystemTheme';

export function withSystemTheme<T extends {}>(WrappedComponent: ComponentType<T>) {
	const Wrapped = (props: T) => {
		useSystemTheme();

		return <WrappedComponent {...props} />;
	};

	return Wrapped;
}
